var AccessoryType = /* @__PURE__ */ ((AccessoryType2) => {
  AccessoryType2["AUDIO_BATTERY"] = "AUDIO_BATTERY";
  AccessoryType2["AUDIO_CLEANING"] = "AUDIO_CLEANING";
  AccessoryType2["AUDIO_EARPLUG"] = "AUDIO_EARPLUG";
  AccessoryType2["AUDIO_HEADSET"] = "AUDIO_HEADSET";
  AccessoryType2["BLUEFILTER_MASK_CLIPS"] = "BLUEFILTER_MASK_CLIPS";
  AccessoryType2["CASES"] = "CASES";
  AccessoryType2["CHARMS"] = "CHARMS";
  AccessoryType2["CLEANING_CLOTH"] = "CLEANING_CLOTH";
  AccessoryType2["CLEANING_LIQUID"] = "CLEANING_LIQUID";
  AccessoryType2["CORDS"] = "CORDS";
  AccessoryType2["MAGNETS"] = "MAGNETS";
  AccessoryType2["MISCELLANEOUS"] = "MISCELLANEOUS";
  AccessoryType2["NIGHTDRIVE_MASK_CLIPS"] = "NIGHTDRIVE_MASK_CLIPS";
  AccessoryType2["SKI_GOGGLES"] = "SKI_GOGGLES";
  AccessoryType2["SLIDERS"] = "SLIDERS";
  AccessoryType2["SUNCOVER"] = "SUNCOVER";
  AccessoryType2["SUN_MASK_CLIPS"] = "SUN_MASK_CLIPS";
  AccessoryType2["SWIMMING_GOGGLES"] = "SWIMMING_GOGGLES";
  return AccessoryType2;
})(AccessoryType || {});
var AccountOrigination = /* @__PURE__ */ ((AccountOrigination2) => {
  AccountOrigination2["IN_STORE"] = "IN_STORE";
  AccountOrigination2["ONLINE"] = "ONLINE";
  return AccountOrigination2;
})(AccountOrigination || {});
var AccountReason = /* @__PURE__ */ ((AccountReason2) => {
  AccountReason2["APPOINTMENT"] = "APPOINTMENT";
  AccountReason2["ORDER"] = "ORDER";
  AccountReason2["SIGN_UP"] = "SIGN_UP";
  AccountReason2["SUBSCRIPTION"] = "SUBSCRIPTION";
  return AccountReason2;
})(AccountReason || {});
var AccountVerificationMethod = /* @__PURE__ */ ((AccountVerificationMethod2) => {
  AccountVerificationMethod2["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
  AccountVerificationMethod2["NONE"] = "NONE";
  return AccountVerificationMethod2;
})(AccountVerificationMethod || {});
var AppointmentCommunicationChannel = /* @__PURE__ */ ((AppointmentCommunicationChannel2) => {
  AppointmentCommunicationChannel2["EMAIL"] = "EMAIL";
  AppointmentCommunicationChannel2["SMS"] = "SMS";
  return AppointmentCommunicationChannel2;
})(AppointmentCommunicationChannel || {});
var AppointmentTypeAgeGroup = /* @__PURE__ */ ((AppointmentTypeAgeGroup2) => {
  AppointmentTypeAgeGroup2["ADULT"] = "ADULT";
  AppointmentTypeAgeGroup2["CHILD"] = "CHILD";
  AppointmentTypeAgeGroup2["SENIOR"] = "SENIOR";
  return AppointmentTypeAgeGroup2;
})(AppointmentTypeAgeGroup || {});
var BillingFrequency = /* @__PURE__ */ ((BillingFrequency2) => {
  BillingFrequency2["MONTHLY"] = "MONTHLY";
  BillingFrequency2["QUARTERLY"] = "QUARTERLY";
  return BillingFrequency2;
})(BillingFrequency || {});
var BundleLineItemProductType = /* @__PURE__ */ ((BundleLineItemProductType2) => {
  BundleLineItemProductType2["LENS"] = "LENS";
  BundleLineItemProductType2["SOLUTION"] = "SOLUTION";
  return BundleLineItemProductType2;
})(BundleLineItemProductType || {});
var BundleLineItemType = /* @__PURE__ */ ((BundleLineItemType2) => {
  BundleLineItemType2["NON_PRESCRIPTION_BUNDLE"] = "NON_PRESCRIPTION_BUNDLE";
  BundleLineItemType2["PRESCRIPTION_GLASSES"] = "PRESCRIPTION_GLASSES";
  return BundleLineItemType2;
})(BundleLineItemType || {});
var CacheControlScope = /* @__PURE__ */ ((CacheControlScope2) => {
  CacheControlScope2["PRIVATE"] = "PRIVATE";
  CacheControlScope2["PUBLIC"] = "PUBLIC";
  return CacheControlScope2;
})(CacheControlScope || {});
var CartAppliedDiscountType = /* @__PURE__ */ ((CartAppliedDiscountType2) => {
  CartAppliedDiscountType2["APPLIED_CART_DISCOUNT"] = "APPLIED_CART_DISCOUNT";
  CartAppliedDiscountType2["APPLIED_DISCOUNT_CODE"] = "APPLIED_DISCOUNT_CODE";
  CartAppliedDiscountType2["UNAPPLIED_DISCOUNT_CODE"] = "UNAPPLIED_DISCOUNT_CODE";
  return CartAppliedDiscountType2;
})(CartAppliedDiscountType || {});
var CartCustomerType = /* @__PURE__ */ ((CartCustomerType2) => {
  CartCustomerType2["B2B"] = "B2B";
  CartCustomerType2["B2C"] = "B2C";
  return CartCustomerType2;
})(CartCustomerType || {});
var CartDiscountType = /* @__PURE__ */ ((CartDiscountType2) => {
  CartDiscountType2["AMOUNT"] = "AMOUNT";
  CartDiscountType2["CART_DISCOUNT"] = "CART_DISCOUNT";
  CartDiscountType2["CART_TOTAL_PRICE_DISCOUNT"] = "CART_TOTAL_PRICE_DISCOUNT";
  CartDiscountType2["PERCENT"] = "PERCENT";
  CartDiscountType2["PRODUCT_DISCOUNT"] = "PRODUCT_DISCOUNT";
  return CartDiscountType2;
})(CartDiscountType || {});
var CartState = /* @__PURE__ */ ((CartState2) => {
  CartState2["Active"] = "Active";
  CartState2["Merged"] = "Merged";
  CartState2["Ordered"] = "Ordered";
  return CartState2;
})(CartState || {});
var ChannelAvailability = /* @__PURE__ */ ((ChannelAvailability2) => {
  ChannelAvailability2["IN_STORE_ONLY"] = "IN_STORE_ONLY";
  ChannelAvailability2["ONLINE"] = "ONLINE";
  return ChannelAvailability2;
})(ChannelAvailability || {});
var ChannelType = /* @__PURE__ */ ((ChannelType2) => {
  ChannelType2["ONLINE"] = "ONLINE";
  ChannelType2["STORE"] = "STORE";
  return ChannelType2;
})(ChannelType || {});
var CheckoutCustomerType = /* @__PURE__ */ ((CheckoutCustomerType2) => {
  CheckoutCustomerType2["B2B"] = "B2B";
  CheckoutCustomerType2["B2C"] = "B2C";
  return CheckoutCustomerType2;
})(CheckoutCustomerType || {});
var CheckoutState = /* @__PURE__ */ ((CheckoutState2) => {
  CheckoutState2["Finalized"] = "Finalized";
  CheckoutState2["InProgress"] = "InProgress";
  CheckoutState2["ReadyToOrder"] = "ReadyToOrder";
  return CheckoutState2;
})(CheckoutState || {});
var CheckoutType = /* @__PURE__ */ ((CheckoutType2) => {
  CheckoutType2["EXPRESS"] = "EXPRESS";
  CheckoutType2["REGULAR"] = "REGULAR";
  return CheckoutType2;
})(CheckoutType || {});
var ColorType = /* @__PURE__ */ ((ColorType2) => {
  ColorType2["SINGLE_GRADIENT"] = "SINGLE_GRADIENT";
  ColorType2["SOLID"] = "SOLID";
  return ColorType2;
})(ColorType || {});
var CompleteSocialLoginFailureType = /* @__PURE__ */ ((CompleteSocialLoginFailureType2) => {
  CompleteSocialLoginFailureType2["AUTHENTICATION"] = "AUTHENTICATION";
  CompleteSocialLoginFailureType2["FEATURE_DISABLED"] = "FEATURE_DISABLED";
  CompleteSocialLoginFailureType2["UNKNOWN"] = "UNKNOWN";
  return CompleteSocialLoginFailureType2;
})(CompleteSocialLoginFailureType || {});
var CreateAccountTargetAction = /* @__PURE__ */ ((CreateAccountTargetAction2) => {
  CreateAccountTargetAction2["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
  CreateAccountTargetAction2["SIGN_UP"] = "SIGN_UP";
  return CreateAccountTargetAction2;
})(CreateAccountTargetAction || {});
var CustomerType = /* @__PURE__ */ ((CustomerType2) => {
  CustomerType2["B2B"] = "B2B";
  CustomerType2["B2C"] = "B2C";
  return CustomerType2;
})(CustomerType || {});
var DayOfWeek = /* @__PURE__ */ ((DayOfWeek2) => {
  DayOfWeek2["FRIDAY"] = "FRIDAY";
  DayOfWeek2["MONDAY"] = "MONDAY";
  DayOfWeek2["SATURDAY"] = "SATURDAY";
  DayOfWeek2["SUNDAY"] = "SUNDAY";
  DayOfWeek2["THURSDAY"] = "THURSDAY";
  DayOfWeek2["TUESDAY"] = "TUESDAY";
  DayOfWeek2["WEDNESDAY"] = "WEDNESDAY";
  return DayOfWeek2;
})(DayOfWeek || {});
var DeliveryFrequency = /* @__PURE__ */ ((DeliveryFrequency2) => {
  DeliveryFrequency2["MONTHLY"] = "MONTHLY";
  DeliveryFrequency2["QUARTERLY"] = "QUARTERLY";
  return DeliveryFrequency2;
})(DeliveryFrequency || {});
var DiscountProductType = /* @__PURE__ */ ((DiscountProductType2) => {
  DiscountProductType2["CART_DISCOUNT"] = "CART_DISCOUNT";
  DiscountProductType2["PRODUCT_DISCOUNT"] = "PRODUCT_DISCOUNT";
  return DiscountProductType2;
})(DiscountProductType || {});
var DiscountType = /* @__PURE__ */ ((DiscountType2) => {
  DiscountType2["ABSOLUTE"] = "ABSOLUTE";
  DiscountType2["CartDiscount"] = "CartDiscount";
  DiscountType2["ProductDiscount"] = "ProductDiscount";
  DiscountType2["RELATIVE"] = "RELATIVE";
  return DiscountType2;
})(DiscountType || {});
var DiscountValueType = /* @__PURE__ */ ((DiscountValueType2) => {
  DiscountValueType2["ABSOLUTE"] = "ABSOLUTE";
  DiscountValueType2["GIFT"] = "GIFT";
  DiscountValueType2["RELATIVE"] = "RELATIVE";
  return DiscountValueType2;
})(DiscountValueType || {});
var Dominance = /* @__PURE__ */ ((Dominance2) => {
  Dominance2["D"] = "D";
  Dominance2["N"] = "N";
  return Dominance2;
})(Dominance || {});
var EyeSide = /* @__PURE__ */ ((EyeSide2) => {
  EyeSide2["BOTH"] = "BOTH";
  EyeSide2["LEFT"] = "LEFT";
  EyeSide2["RIGHT"] = "RIGHT";
  return EyeSide2;
})(EyeSide || {});
var FaceShape = /* @__PURE__ */ ((FaceShape2) => {
  FaceShape2["DIAMOND"] = "DIAMOND";
  FaceShape2["HEART"] = "HEART";
  FaceShape2["OBLONG"] = "OBLONG";
  FaceShape2["OVAL"] = "OVAL";
  FaceShape2["RECTANGLE"] = "RECTANGLE";
  FaceShape2["ROUND"] = "ROUND";
  FaceShape2["SQUARE"] = "SQUARE";
  FaceShape2["TRIANGLE"] = "TRIANGLE";
  return FaceShape2;
})(FaceShape || {});
var FilterFieldNames = /* @__PURE__ */ ((FilterFieldNames2) => {
  FilterFieldNames2["group"] = "group";
  FilterFieldNames2["slug"] = "slug";
  return FilterFieldNames2;
})(FilterFieldNames || {});
var FrameShape = /* @__PURE__ */ ((FrameShape2) => {
  FrameShape2["ALMOND"] = "ALMOND";
  FrameShape2["AVIATOR"] = "AVIATOR";
  FrameShape2["BUTTERFLY"] = "BUTTERFLY";
  FrameShape2["CAT_EYE"] = "CAT_EYE";
  FrameShape2["HEXAGONAL"] = "HEXAGONAL";
  FrameShape2["IRREGULAR"] = "IRREGULAR";
  FrameShape2["MASK"] = "MASK";
  FrameShape2["OVAL"] = "OVAL";
  FrameShape2["PANTO"] = "PANTO";
  FrameShape2["PILLOW"] = "PILLOW";
  FrameShape2["PILOT"] = "PILOT";
  FrameShape2["RECATANGLE_SQUARE"] = "RECATANGLE_SQUARE";
  FrameShape2["RECTANGLE"] = "RECTANGLE";
  FrameShape2["ROUND"] = "ROUND";
  FrameShape2["ROUND_OVAL"] = "ROUND_OVAL";
  FrameShape2["SHIELD"] = "SHIELD";
  FrameShape2["SQUARE"] = "SQUARE";
  FrameShape2["UNDEFINED"] = "UNDEFINED";
  return FrameShape2;
})(FrameShape || {});
var FrameSize = /* @__PURE__ */ ((FrameSize2) => {
  FrameSize2["EXTRA_SMALL"] = "EXTRA_SMALL";
  FrameSize2["LARGE"] = "LARGE";
  FrameSize2["MEDIUM"] = "MEDIUM";
  FrameSize2["SMALL"] = "SMALL";
  return FrameSize2;
})(FrameSize || {});
var FrameType = /* @__PURE__ */ ((FrameType2) => {
  FrameType2["CLIPS"] = "CLIPS";
  FrameType2["GOOGLE"] = "GOOGLE";
  FrameType2["HALF_EYE"] = "HALF_EYE";
  FrameType2["MASK"] = "MASK";
  FrameType2["SAFETY"] = "SAFETY";
  FrameType2["STANDARD"] = "STANDARD";
  return FrameType2;
})(FrameType || {});
var HttpMethod = /* @__PURE__ */ ((HttpMethod2) => {
  HttpMethod2["GET"] = "GET";
  HttpMethod2["POST"] = "POST";
  return HttpMethod2;
})(HttpMethod || {});
var InsuranceType = /* @__PURE__ */ ((InsuranceType2) => {
  InsuranceType2["GRAND_ADVANTAGE"] = "GRAND_ADVANTAGE";
  return InsuranceType2;
})(InsuranceType || {});
var Intent = /* @__PURE__ */ ((Intent2) => {
  Intent2["AUTHORIZE"] = "AUTHORIZE";
  Intent2["CAPTURE"] = "CAPTURE";
  return Intent2;
})(Intent || {});
var LineItemType = /* @__PURE__ */ ((LineItemType2) => {
  LineItemType2["BUNDLE"] = "BUNDLE";
  LineItemType2["CONTACTLENSES"] = "CONTACTLENSES";
  LineItemType2["INSURANCE"] = "INSURANCE";
  LineItemType2["REGULAR"] = "REGULAR";
  return LineItemType2;
})(LineItemType || {});
var LoyaltyCardNumber = /* @__PURE__ */ ((LoyaltyCardNumber2) => {
  LoyaltyCardNumber2["LUHN"] = "LUHN";
  LoyaltyCardNumber2["UUID"] = "UUID";
  return LoyaltyCardNumber2;
})(LoyaltyCardNumber || {});
var MaterialGroup = /* @__PURE__ */ ((MaterialGroup2) => {
  MaterialGroup2["COMBI"] = "COMBI";
  MaterialGroup2["HYBRID"] = "HYBRID";
  MaterialGroup2["HYDROGEL"] = "HYDROGEL";
  MaterialGroup2["METAL"] = "METAL";
  MaterialGroup2["MINERAL"] = "MINERAL";
  MaterialGroup2["ORGANIC"] = "ORGANIC";
  MaterialGroup2["PLASTIC"] = "PLASTIC";
  MaterialGroup2["RIGID_GAS_PERMIABLE"] = "RIGID_GAS_PERMIABLE";
  MaterialGroup2["SILICONE_HYDROGEL"] = "SILICONE_HYDROGEL";
  MaterialGroup2["UNKNOWN"] = "UNKNOWN";
  return MaterialGroup2;
})(MaterialGroup || {});
var OfferingAction = /* @__PURE__ */ ((OfferingAction2) => {
  OfferingAction2["ADD_TO_CART"] = "ADD_TO_CART";
  OfferingAction2["ADD_TO_CART_UNAVAILABLE"] = "ADD_TO_CART_UNAVAILABLE";
  OfferingAction2["OPEN_CONFIGURATOR"] = "OPEN_CONFIGURATOR";
  OfferingAction2["OPEN_CONFIGURATOR_UNAVAILABLE"] = "OPEN_CONFIGURATOR_UNAVAILABLE";
  return OfferingAction2;
})(OfferingAction || {});
var OneyPaymentMethod = /* @__PURE__ */ ((OneyPaymentMethod2) => {
  OneyPaymentMethod2["ONEY_3X"] = "ONEY_3X";
  OneyPaymentMethod2["ONEY_4X"] = "ONEY_4X";
  return OneyPaymentMethod2;
})(OneyPaymentMethod || {});
var OrderDeliveryMethod = /* @__PURE__ */ ((OrderDeliveryMethod2) => {
  OrderDeliveryMethod2["HOME_DELIVERY"] = "HOME_DELIVERY";
  OrderDeliveryMethod2["HOME_DELIVERY_EXPRESS"] = "HOME_DELIVERY_EXPRESS";
  OrderDeliveryMethod2["NEAREST_PICK_UP"] = "NEAREST_PICK_UP";
  OrderDeliveryMethod2["PICK_UP"] = "PICK_UP";
  OrderDeliveryMethod2["PICK_UP_POINT"] = "PICK_UP_POINT";
  return OrderDeliveryMethod2;
})(OrderDeliveryMethod || {});
var OrderDiscountType = /* @__PURE__ */ ((OrderDiscountType2) => {
  OrderDiscountType2["CART_DISCOUNT"] = "CART_DISCOUNT";
  OrderDiscountType2["PRODUCT_DISCOUNT"] = "PRODUCT_DISCOUNT";
  return OrderDiscountType2;
})(OrderDiscountType || {});
var OrderLoyaltyCardNumber = /* @__PURE__ */ ((OrderLoyaltyCardNumber2) => {
  OrderLoyaltyCardNumber2["LUHN"] = "LUHN";
  OrderLoyaltyCardNumber2["UUID"] = "UUID";
  return OrderLoyaltyCardNumber2;
})(OrderLoyaltyCardNumber || {});
var OrderPaymentMethod = /* @__PURE__ */ ((OrderPaymentMethod2) => {
  OrderPaymentMethod2["APPLE_PAY"] = "APPLE_PAY";
  OrderPaymentMethod2["BANCONTACT_CARD"] = "BANCONTACT_CARD";
  OrderPaymentMethod2["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
  OrderPaymentMethod2["BIZUM"] = "BIZUM";
  OrderPaymentMethod2["CARD"] = "CARD";
  OrderPaymentMethod2["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
  OrderPaymentMethod2["FAKE"] = "FAKE";
  OrderPaymentMethod2["GOOGLE_PAY"] = "GOOGLE_PAY";
  OrderPaymentMethod2["IDEAL"] = "IDEAL";
  OrderPaymentMethod2["INVOICE"] = "INVOICE";
  OrderPaymentMethod2["KLARNA"] = "KLARNA";
  OrderPaymentMethod2["KLARNA_ACCOUNT"] = "KLARNA_ACCOUNT";
  OrderPaymentMethod2["KLARNA_PAY_NOW"] = "KLARNA_PAY_NOW";
  OrderPaymentMethod2["MBWAY"] = "MBWAY";
  OrderPaymentMethod2["MOBILEPAY"] = "MOBILEPAY";
  OrderPaymentMethod2["MULTIBANCO"] = "MULTIBANCO";
  OrderPaymentMethod2["ONEY"] = "ONEY";
  OrderPaymentMethod2["ONEY_3X"] = "ONEY_3X";
  OrderPaymentMethod2["ONEY_4X"] = "ONEY_4X";
  OrderPaymentMethod2["PAYPAL"] = "PAYPAL";
  OrderPaymentMethod2["SEPA"] = "SEPA";
  OrderPaymentMethod2["SWISH"] = "SWISH";
  OrderPaymentMethod2["TWINT"] = "TWINT";
  return OrderPaymentMethod2;
})(OrderPaymentMethod || {});
var OrderPaymentStatus = /* @__PURE__ */ ((OrderPaymentStatus2) => {
  OrderPaymentStatus2["BALANCE_DUE"] = "BALANCE_DUE";
  OrderPaymentStatus2["CREDIT_OWED"] = "CREDIT_OWED";
  OrderPaymentStatus2["FAILED"] = "FAILED";
  OrderPaymentStatus2["PAID"] = "PAID";
  OrderPaymentStatus2["PENDING"] = "PENDING";
  return OrderPaymentStatus2;
})(OrderPaymentStatus || {});
var OrderShipmentStatus = /* @__PURE__ */ ((OrderShipmentStatus2) => {
  OrderShipmentStatus2["BACK_ORDER"] = "BACK_ORDER";
  OrderShipmentStatus2["DELAYED"] = "DELAYED";
  OrderShipmentStatus2["PARTIAL"] = "PARTIAL";
  OrderShipmentStatus2["PENDING"] = "PENDING";
  OrderShipmentStatus2["READY"] = "READY";
  OrderShipmentStatus2["SHIPPED"] = "SHIPPED";
  return OrderShipmentStatus2;
})(OrderShipmentStatus || {});
var PSP = /* @__PURE__ */ ((PSP2) => {
  PSP2["ADYEN"] = "ADYEN";
  PSP2["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
  PSP2["FAKE"] = "FAKE";
  PSP2["MFGROUP"] = "MFGROUP";
  PSP2["PAYPAL"] = "PAYPAL";
  return PSP2;
})(PSP || {});
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["APPLE_PAY"] = "APPLE_PAY";
  PaymentMethod2["BANCONTACT_CARD"] = "BANCONTACT_CARD";
  PaymentMethod2["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
  PaymentMethod2["BIZUM"] = "BIZUM";
  PaymentMethod2["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
  PaymentMethod2["CREDITCARD"] = "CREDITCARD";
  PaymentMethod2["FAKE"] = "FAKE";
  PaymentMethod2["GOOGLE_PAY"] = "GOOGLE_PAY";
  PaymentMethod2["IDEAL"] = "IDEAL";
  PaymentMethod2["INVOICE"] = "INVOICE";
  PaymentMethod2["KLARNA"] = "KLARNA";
  PaymentMethod2["KLARNA_ACCOUNT"] = "KLARNA_ACCOUNT";
  PaymentMethod2["KLARNA_PAY_NOW"] = "KLARNA_PAY_NOW";
  PaymentMethod2["MBWAY"] = "MBWAY";
  PaymentMethod2["MOBILE_PAY"] = "MOBILE_PAY";
  PaymentMethod2["MULTIBANCO"] = "MULTIBANCO";
  PaymentMethod2["ONEY"] = "ONEY";
  PaymentMethod2["PAYPAL"] = "PAYPAL";
  PaymentMethod2["SEPA_DIRECT_DEBIT"] = "SEPA_DIRECT_DEBIT";
  PaymentMethod2["SWISH"] = "SWISH";
  PaymentMethod2["TWINT"] = "TWINT";
  return PaymentMethod2;
})(PaymentMethod || {});
var PaymentState = /* @__PURE__ */ ((PaymentState2) => {
  PaymentState2["Cancelled"] = "Cancelled";
  PaymentState2["Failed"] = "Failed";
  PaymentState2["Paid"] = "Paid";
  PaymentState2["Pending"] = "Pending";
  return PaymentState2;
})(PaymentState || {});
var PaypalOrderStatus = /* @__PURE__ */ ((PaypalOrderStatus2) => {
  PaypalOrderStatus2["APPROVED"] = "APPROVED";
  PaypalOrderStatus2["COMPLETED"] = "COMPLETED";
  PaypalOrderStatus2["CREATED"] = "CREATED";
  PaypalOrderStatus2["PAYER_ACTION_REQUIRED"] = "PAYER_ACTION_REQUIRED";
  PaypalOrderStatus2["SAVED"] = "SAVED";
  PaypalOrderStatus2["VOIDED"] = "VOIDED";
  return PaypalOrderStatus2;
})(PaypalOrderStatus || {});
var PaypalVerificationStatus = /* @__PURE__ */ ((PaypalVerificationStatus2) => {
  PaypalVerificationStatus2["FAILURE"] = "FAILURE";
  PaypalVerificationStatus2["SUCCESS"] = "SUCCESS";
  return PaypalVerificationStatus2;
})(PaypalVerificationStatus || {});
var PickupPointType = /* @__PURE__ */ ((PickupPointType2) => {
  PickupPointType2["FOREIGN_POST_OFFICE"] = "FOREIGN_POST_OFFICE";
  PickupPointType2["LOCAL_LOCKERS"] = "LOCAL_LOCKERS";
  PickupPointType2["LOCAL_POST_AGENCY"] = "LOCAL_POST_AGENCY";
  PickupPointType2["LOCAL_POST_DISTRIBUTIION_CENTRE"] = "LOCAL_POST_DISTRIBUTIION_CENTRE";
  PickupPointType2["LOCAL_POST_OFFICE"] = "LOCAL_POST_OFFICE";
  PickupPointType2["LOCAL_SHOPS"] = "LOCAL_SHOPS";
  PickupPointType2["LOCAL_SHOPS_ABROAD"] = "LOCAL_SHOPS_ABROAD";
  return PickupPointType2;
})(PickupPointType || {});
var PrescriptionGlassesOptionType = /* @__PURE__ */ ((PrescriptionGlassesOptionType2) => {
  PrescriptionGlassesOptionType2["BLUE_LIGHT_FILTER"] = "BLUE_LIGHT_FILTER";
  PrescriptionGlassesOptionType2["MIRRORING"] = "MIRRORING";
  PrescriptionGlassesOptionType2["PHOTOCHROMIC"] = "PHOTOCHROMIC";
  PrescriptionGlassesOptionType2["POLARISING"] = "POLARISING";
  return PrescriptionGlassesOptionType2;
})(PrescriptionGlassesOptionType || {});
var PrescriptionGlassesPackageOptionsTransitionType = /* @__PURE__ */ ((PrescriptionGlassesPackageOptionsTransitionType2) => {
  PrescriptionGlassesPackageOptionsTransitionType2["SIGNATURE"] = "SIGNATURE";
  PrescriptionGlassesPackageOptionsTransitionType2["XTRACTIVE"] = "XTRACTIVE";
  return PrescriptionGlassesPackageOptionsTransitionType2;
})(PrescriptionGlassesPackageOptionsTransitionType || {});
var PrescriptionSource = /* @__PURE__ */ ((PrescriptionSource2) => {
  PrescriptionSource2["MANUAL"] = "MANUAL";
  PrescriptionSource2["OCR"] = "OCR";
  return PrescriptionSource2;
})(PrescriptionSource || {});
var PrescriptionType = /* @__PURE__ */ ((PrescriptionType2) => {
  PrescriptionType2["CONTACT_LENS_PRESCRIPTION"] = "CONTACT_LENS_PRESCRIPTION";
  PrescriptionType2["HEARING_AID_PRESCRIPTION"] = "HEARING_AID_PRESCRIPTION";
  PrescriptionType2["PRESCRIPTION_GLASSES_PRESCRIPTION"] = "PRESCRIPTION_GLASSES_PRESCRIPTION";
  return PrescriptionType2;
})(PrescriptionType || {});
var PrescriptionValuesFromDocumentResultCode = /* @__PURE__ */ ((PrescriptionValuesFromDocumentResultCode2) => {
  PrescriptionValuesFromDocumentResultCode2["ERROR"] = "ERROR";
  PrescriptionValuesFromDocumentResultCode2["OCR_UNAVAILABLE"] = "OCR_UNAVAILABLE";
  PrescriptionValuesFromDocumentResultCode2["SUCCESS"] = "SUCCESS";
  return PrescriptionValuesFromDocumentResultCode2;
})(PrescriptionValuesFromDocumentResultCode || {});
var ProductPriceItemType = /* @__PURE__ */ ((ProductPriceItemType2) => {
  ProductPriceItemType2["SINGLE_PURCHASE"] = "SINGLE_PURCHASE";
  ProductPriceItemType2["SUBSCRIPTION"] = "SUBSCRIPTION";
  return ProductPriceItemType2;
})(ProductPriceItemType || {});
var QuoteProductType = /* @__PURE__ */ ((QuoteProductType2) => {
  QuoteProductType2["CONTACT_LENSES"] = "CONTACT_LENSES";
  QuoteProductType2["OTHER"] = "OTHER";
  QuoteProductType2["PRESCRIPTION_GLASSES_BUNDLE"] = "PRESCRIPTION_GLASSES_BUNDLE";
  return QuoteProductType2;
})(QuoteProductType || {});
var RecommendationDiscountType = /* @__PURE__ */ ((RecommendationDiscountType2) => {
  RecommendationDiscountType2["CART_DISCOUNT"] = "CART_DISCOUNT";
  RecommendationDiscountType2["PRODUCT_DISCOUNT"] = "PRODUCT_DISCOUNT";
  return RecommendationDiscountType2;
})(RecommendationDiscountType || {});
var ReplacementFrequency = /* @__PURE__ */ ((ReplacementFrequency2) => {
  ReplacementFrequency2["BI_WEEKLY"] = "BI_WEEKLY";
  ReplacementFrequency2["DAILY"] = "DAILY";
  ReplacementFrequency2["MONTHLY"] = "MONTHLY";
  return ReplacementFrequency2;
})(ReplacementFrequency || {});
var RequestSocialLoginMergeFailureType = /* @__PURE__ */ ((RequestSocialLoginMergeFailureType2) => {
  RequestSocialLoginMergeFailureType2["AUTHENTICATION"] = "AUTHENTICATION";
  RequestSocialLoginMergeFailureType2["FEATURE_DISABLED"] = "FEATURE_DISABLED";
  RequestSocialLoginMergeFailureType2["UNKNOWN"] = "UNKNOWN";
  return RequestSocialLoginMergeFailureType2;
})(RequestSocialLoginMergeFailureType || {});
var ReservationState = /* @__PURE__ */ ((ReservationState2) => {
  ReservationState2["CANCELLED"] = "CANCELLED";
  ReservationState2["CLOSED"] = "CLOSED";
  ReservationState2["CLOSED_NO_SHOW"] = "CLOSED_NO_SHOW";
  ReservationState2["CLOSED_SHOW"] = "CLOSED_SHOW";
  ReservationState2["CONFIRMED"] = "CONFIRMED";
  ReservationState2["REJECTED_AUTOMATICALLY"] = "REJECTED_AUTOMATICALLY";
  ReservationState2["REJECTED_BY_STORE"] = "REJECTED_BY_STORE";
  ReservationState2["REQUESTED"] = "REQUESTED";
  ReservationState2["UNKNOWN"] = "UNKNOWN";
  return ReservationState2;
})(ReservationState || {});
var ResultType = /* @__PURE__ */ ((ResultType2) => {
  ResultType2["AUTHORISED"] = "AUTHORISED";
  ResultType2["CANCELLED"] = "CANCELLED";
  ResultType2["ERROR"] = "ERROR";
  ResultType2["PENDING"] = "PENDING";
  ResultType2["QRCODE"] = "QRCODE";
  ResultType2["RECEIVED"] = "RECEIVED";
  ResultType2["REDIRECT"] = "REDIRECT";
  ResultType2["REFUSED"] = "REFUSED";
  ResultType2["VOUCHER"] = "VOUCHER";
  return ResultType2;
})(ResultType || {});
var ReturnStatus = /* @__PURE__ */ ((ReturnStatus2) => {
  ReturnStatus2["NOT_RETURNABLE"] = "NOT_RETURNABLE";
  ReturnStatus2["RETURNABLE"] = "RETURNABLE";
  ReturnStatus2["RETURNED"] = "RETURNED";
  ReturnStatus2["RETURN_REQUESTED"] = "RETURN_REQUESTED";
  return ReturnStatus2;
})(ReturnStatus || {});
var RimType = /* @__PURE__ */ ((RimType2) => {
  RimType2["FULL_RIM"] = "FULL_RIM";
  RimType2["HALF_RIM"] = "HALF_RIM";
  RimType2["RIMLESS"] = "RIMLESS";
  RimType2["UNKNOWN"] = "UNKNOWN";
  return RimType2;
})(RimType || {});
var Roadworthiness = /* @__PURE__ */ ((Roadworthiness2) => {
  Roadworthiness2["DAY_AND_NIGHT"] = "DAY_AND_NIGHT";
  Roadworthiness2["DAY_ONE"] = "DAY_ONE";
  Roadworthiness2["DAY_ONLY"] = "DAY_ONLY";
  Roadworthiness2["DAY_THREE"] = "DAY_THREE";
  Roadworthiness2["DAY_TWO"] = "DAY_TWO";
  Roadworthiness2["NOT_AT_ALL"] = "NOT_AT_ALL";
  return Roadworthiness2;
})(Roadworthiness || {});
var SanitizationAction = /* @__PURE__ */ ((SanitizationAction2) => {
  SanitizationAction2["KeepExisting"] = "KeepExisting";
  SanitizationAction2["Replace"] = "Replace";
  return SanitizationAction2;
})(SanitizationAction || {});
var ServicesNotAvailable = /* @__PURE__ */ ((ServicesNotAvailable2) => {
  ServicesNotAvailable2["APPOINTMENTS"] = "APPOINTMENTS";
  ServicesNotAvailable2["CLICK_AND_RESERVE"] = "CLICK_AND_RESERVE";
  ServicesNotAvailable2["EVENING_APPOINTMENTS"] = "EVENING_APPOINTMENTS";
  ServicesNotAvailable2["OPTOMETRY"] = "OPTOMETRY";
  ServicesNotAvailable2["PICK_UP_IN_STORE"] = "PICK_UP_IN_STORE";
  return ServicesNotAvailable2;
})(ServicesNotAvailable || {});
var ShoppinglistType = /* @__PURE__ */ ((ShoppinglistType2) => {
  ShoppinglistType2["WISHLIST"] = "WISHLIST";
  return ShoppinglistType2;
})(ShoppinglistType || {});
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["OFFLINE"] = "OFFLINE";
  Status2["ONLINE"] = "ONLINE";
  return Status2;
})(Status || {});
var StockIndicator = /* @__PURE__ */ ((StockIndicator2) => {
  StockIndicator2["IN_STOCK"] = "IN_STOCK";
  StockIndicator2["LOW_STOCK"] = "LOW_STOCK";
  StockIndicator2["OUT_OF_STOCK"] = "OUT_OF_STOCK";
  StockIndicator2["UNKNOWN"] = "UNKNOWN";
  return StockIndicator2;
})(StockIndicator || {});
var StoreAppointmentDurationUnit = /* @__PURE__ */ ((StoreAppointmentDurationUnit2) => {
  StoreAppointmentDurationUnit2["MINUTES"] = "MINUTES";
  return StoreAppointmentDurationUnit2;
})(StoreAppointmentDurationUnit || {});
var StoreOfferType = /* @__PURE__ */ ((StoreOfferType2) => {
  StoreOfferType2["OFFER"] = "OFFER";
  return StoreOfferType2;
})(StoreOfferType || {});
var SubscriptionDeliveryHistorySort = /* @__PURE__ */ ((SubscriptionDeliveryHistorySort2) => {
  SubscriptionDeliveryHistorySort2["ASC"] = "ASC";
  SubscriptionDeliveryHistorySort2["DESC"] = "DESC";
  return SubscriptionDeliveryHistorySort2;
})(SubscriptionDeliveryHistorySort || {});
var SubscriptionEyeSide = /* @__PURE__ */ ((SubscriptionEyeSide2) => {
  SubscriptionEyeSide2["LEFT"] = "LEFT";
  SubscriptionEyeSide2["RIGHT"] = "RIGHT";
  return SubscriptionEyeSide2;
})(SubscriptionEyeSide || {});
var SubscriptionPaymentType = /* @__PURE__ */ ((SubscriptionPaymentType2) => {
  SubscriptionPaymentType2["CREDITCARD"] = "CREDITCARD";
  SubscriptionPaymentType2["PAYPAL"] = "PAYPAL";
  return SubscriptionPaymentType2;
})(SubscriptionPaymentType || {});
var SubscriptionProductType = /* @__PURE__ */ ((SubscriptionProductType2) => {
  SubscriptionProductType2["CONTACT_LENSES"] = "CONTACT_LENSES";
  SubscriptionProductType2["SOLUTIONS"] = "SOLUTIONS";
  return SubscriptionProductType2;
})(SubscriptionProductType || {});
var SubscriptionPspType = /* @__PURE__ */ ((SubscriptionPspType2) => {
  SubscriptionPspType2["ADYEN"] = "ADYEN";
  SubscriptionPspType2["PAYPAL"] = "PAYPAL";
  return SubscriptionPspType2;
})(SubscriptionPspType || {});
var TargetGender = /* @__PURE__ */ ((TargetGender2) => {
  TargetGender2["FEMALE"] = "FEMALE";
  TargetGender2["MALE"] = "MALE";
  TargetGender2["UNDEFINED"] = "UNDEFINED";
  TargetGender2["UNISEX"] = "UNISEX";
  return TargetGender2;
})(TargetGender || {});
var UIElementType = /* @__PURE__ */ ((UIElementType2) => {
  UIElementType2["CHECKBOX"] = "CHECKBOX";
  return UIElementType2;
})(UIElementType || {});
var UIType = /* @__PURE__ */ ((UIType2) => {
  UIType2["CHECKBOX"] = "CHECKBOX";
  return UIType2;
})(UIType || {});
var ValidationCode = /* @__PURE__ */ ((ValidationCode2) => {
  ValidationCode2["CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES"] = "CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES";
  ValidationCode2["HAS_VALID_OPTICIAN_DETAILS"] = "HAS_VALID_OPTICIAN_DETAILS";
  ValidationCode2["HAS_VALID_PRESCRIPTION_DATA_RANGES"] = "HAS_VALID_PRESCRIPTION_DATA_RANGES";
  ValidationCode2["IS_IN_STOCK"] = "IS_IN_STOCK";
  ValidationCode2["IS_VALID_AMOUNT_OF_MASTER_VARIANTS"] = "IS_VALID_AMOUNT_OF_MASTER_VARIANTS";
  ValidationCode2["IS_VALID_CART_BY_PRESCRIPTION"] = "IS_VALID_CART_BY_PRESCRIPTION";
  ValidationCode2["IS_VALID_EXPIRY_DATE"] = "IS_VALID_EXPIRY_DATE";
  ValidationCode2["IS_VALID_QUANTITY"] = "IS_VALID_QUANTITY";
  ValidationCode2["MAX_QUANTITY_PER_LINE_ITEM_TYPE"] = "MAX_QUANTITY_PER_LINE_ITEM_TYPE";
  ValidationCode2["MAX_QUANTITY_PER_PRODUCT_TYPE"] = "MAX_QUANTITY_PER_PRODUCT_TYPE";
  ValidationCode2["MAX_QUANTITY_PER_SKU_LIST"] = "MAX_QUANTITY_PER_SKU_LIST";
  ValidationCode2["MAX_VARIANTS_PER_PRODUCT_TYPE"] = "MAX_VARIANTS_PER_PRODUCT_TYPE";
  ValidationCode2["ONE_LENS_TYPE_PER_EYE"] = "ONE_LENS_TYPE_PER_EYE";
  ValidationCode2["PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT"] = "PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT";
  ValidationCode2["PRODUCTS_ARE_PUBLISHED"] = "PRODUCTS_ARE_PUBLISHED";
  ValidationCode2["REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE"] = "REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE";
  ValidationCode2["VALID_CART_BY_PRODUCT_TYPES"] = "VALID_CART_BY_PRODUCT_TYPES";
  ValidationCode2["VALID_RELATIONS_BUNDLE_PRODUCTS"] = "VALID_RELATIONS_BUNDLE_PRODUCTS";
  return ValidationCode2;
})(ValidationCode || {});
var VoucherState = /* @__PURE__ */ ((VoucherState2) => {
  VoucherState2["ApplicationStoppedByPreviousDiscount"] = "ApplicationStoppedByPreviousDiscount";
  VoucherState2["DoesNotMatchCart"] = "DoesNotMatchCart";
  VoucherState2["MatchesCart"] = "MatchesCart";
  VoucherState2["MaxApplicationReached"] = "MaxApplicationReached";
  VoucherState2["NotActive"] = "NotActive";
  VoucherState2["NotValid"] = "NotValid";
  return VoucherState2;
})(VoucherState || {});
export {
  AccessoryType,
  AccountOrigination,
  AccountReason,
  AccountVerificationMethod,
  AppointmentCommunicationChannel,
  AppointmentTypeAgeGroup,
  BillingFrequency,
  BundleLineItemProductType,
  BundleLineItemType,
  CacheControlScope,
  CartAppliedDiscountType,
  CartCustomerType,
  CartDiscountType,
  CartState,
  ChannelAvailability,
  ChannelType,
  CheckoutCustomerType,
  CheckoutState,
  CheckoutType,
  ColorType,
  CompleteSocialLoginFailureType,
  CreateAccountTargetAction,
  CustomerType,
  DayOfWeek,
  DeliveryFrequency,
  DiscountProductType,
  DiscountType,
  DiscountValueType,
  Dominance,
  EyeSide,
  FaceShape,
  FilterFieldNames,
  FrameShape,
  FrameSize,
  FrameType,
  HttpMethod,
  InsuranceType,
  Intent,
  LineItemType,
  LoyaltyCardNumber,
  MaterialGroup,
  OfferingAction,
  OneyPaymentMethod,
  OrderDeliveryMethod,
  OrderDiscountType,
  OrderLoyaltyCardNumber,
  OrderPaymentMethod,
  OrderPaymentStatus,
  OrderShipmentStatus,
  PSP,
  PaymentMethod,
  PaymentState,
  PaypalOrderStatus,
  PaypalVerificationStatus,
  PickupPointType,
  PrescriptionGlassesOptionType,
  PrescriptionGlassesPackageOptionsTransitionType,
  PrescriptionSource,
  PrescriptionType,
  PrescriptionValuesFromDocumentResultCode,
  ProductPriceItemType,
  QuoteProductType,
  RecommendationDiscountType,
  ReplacementFrequency,
  RequestSocialLoginMergeFailureType,
  ReservationState,
  ResultType,
  ReturnStatus,
  RimType,
  Roadworthiness,
  SanitizationAction,
  ServicesNotAvailable,
  ShoppinglistType,
  Status,
  StockIndicator,
  StoreAppointmentDurationUnit,
  StoreOfferType,
  SubscriptionDeliveryHistorySort,
  SubscriptionEyeSide,
  SubscriptionPaymentType,
  SubscriptionProductType,
  SubscriptionPspType,
  TargetGender,
  UIElementType,
  UIType,
  ValidationCode,
  VoucherState
};
//# sourceMappingURL=generated-types.js.map
